export default __webpack_public_path__ + "static/media/rival_points.5f6f9240.svg";